import { render } from "./config-section.vue?vue&type=template&id=b1c6e9e2&scoped=true"
import script from "./config-section.vue?vue&type=script&lang=js"
export * from "./config-section.vue?vue&type=script&lang=js"

import "./config-section.vue?vue&type=style&index=0&id=b1c6e9e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c6e9e2"]])

export default __exports__